import { Box, Divider, Drawer, IconButton, useMediaQuery } from "@mui/material";
import { Icon } from "components/Icons";
import React from "react";
import { useContactDrawer } from "./useContactDrawer";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { STATICS } from "api/api";
import { useLocation } from "react-router-dom";
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import { useBreak } from "hooks/useBreak";
import ContactForm from "./ContactForm";
import moment from "moment";
import { useTranslation } from "react-i18next";

// Function to remove duplicates from contactData based on unique properties
const removeDuplicates = (data) => {
  const seen = new Set();
  return data.filter((item) => {
    const identifier = `${item?.Name}|${item?.AddressLine1}|${item?.AddressLine2}|${item?.Phone}|${item?.Email}`;
    return !seen.has(identifier) && seen.add(identifier);
  });
};


const ContactDrawer = () => {
   const { i18n: { language }, } = useTranslation();
  const { isOpen, toggle, unit } = useContactDrawer();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isTab = useBreak("md_dn");
  const here = useLocation().pathname;
  const atUnit = here.includes("unit");

  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const contactData =
    getFocus(_project, "ContactProperties")?.[pin]?.[pid] ?? [];

  const isRent = unit?.isRent()
  const type = isRent ? 'rent' : 'sales'


  // Filter out duplicates
  const uniqueContactData = removeDuplicates(contactData);
  const campaignIds = {
    "rent": '8a50a77ef0e3cecb56002ca548ac3929',
    "sales": '8285f3e36611de7f525f6916e7ed71b6',
  }

  const logoUrl = uniqueContactData?.[0]?.ImageUrl
    ? `${STATICS}${uniqueContactData[0].ImageUrl}`
    : null;



  const showText = moment().isBefore("2025-12-09", "day");

  return (
    <Drawer
      hideBackdrop={true}
      anchor={isMobile ? "bottom" : "right"}
      open={isOpen}
      onClose={() => toggle()}
      PaperProps={{
        sx: {
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          color: "secondary.contrastText",
          backgroundColor: "secondary.main",
          height: {
            xs: `calc(100% - 154px - ${atUnit || isTab ? isMobile ? "-114px" : "-120px" : "11px"})`,
          },
          top: `${isMobile ? "52px" : isTab ? "56px" : "71px"}`,
          justifyContent: "space-between",
          boxShadow: "unset",
          paddingBottom: { xs: "16px", lg: 0 },
        },
      }}
      sx={{
        "&.MuiDrawer-root": {
          width: 450,
          top: "70px",
          right: 0,
          left: "unset",
          bottom: "unset",
        },
      }}
    >
      <Box
        sx={{
          width: isMobile ? "auto" : 450,
          position: "relative",
          pt: 4,
          pb: 4,
          px: 3,
          lineHeight: 1.3,
        }}
      >
        <IconButton
          onClick={toggle}
          sx={{
            position: "absolute",
            right: 16,
            color: "#004337",
            top: 16,
          }}
        >
          <Icon
            icon="close"
            isFaIcon={true}
            size={"lg"}
            sx={{
              fontSize: 18,
            }}
          />
        </IconButton>

        {/* === STATIC CONTACT SECTION === */}
        <Box sx={{ mt: 3, lineHeight: 1.6 }}>
          <Box
            sx={{
              fontWeight: 700,
              mb: 2,
              color: "#004337",
              fontSize: "1.1rem",
            }}
          >
            {buttonsLabel?.filter(
              (btn) => btn?.UILabelProperty === "Kontaktinformation"
            )[0]?.Label || "Kontaktinformation"}
          </Box>

          <Box sx={{ color: "#004337", fontSize: "0.95rem" }}>
            {
              buttonsLabel?.find(
                (btn) => btn.UILabelProperty === "TravbyenDialog"
              )?.Label
            }
            <br />
            <strong>
              {" "}
              {
                buttonsLabel?.filter(
                  (btn) => btn?.UILabelProperty === "kontaktOs"
                )[0]?.Label
              }:{" "}
            </strong>
            <a
              href="mailto:kontakt@travbyen.dk"
              style={{
                color: "#004337",
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              kontakt@travbyen.dk
            </a>
          </Box>

          {logoUrl && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 4,
                mb: 2,
              }}
            >
              <img
                src={logoUrl}
                alt="Travbyen logo"
                style={{
                  maxWidth: "160px",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          )}
        </Box>
        <Divider sx={{ my: 4, borderColor: clr?.primary_text,  }} />
        <ContactForm unit={unit} campaignId={campaignIds[type]} drawerType = {'contactDrawer'}>
            <Box className="h3" sx={{ mt: 4, fontWeight: 700, lineHeight: 1.4, }} > 
                        {/* {
                          buttonsLabel?.filter( btn => btn.UILabelProperty ===  
                            // "footerHeading1"
                            "SidefodformularOverskrift"
                          )[0]?.Label
                        } */}
                        {
                          language === "da" ? "Er du interesseret i en bolig, eller har du spørgsmål?" : "Are you interested in a home or do you have a question?"
                        }
                      </Box>
                      <br />
                      <Box className="paragraph1-regular" sx={{ mb: 3 }}>
                        <div>
                          <span>
                            {language === "en"
                              ? "Fill in the form below and one of our partners will contact you by email or phone."
                              : "Udfyld nedenstående formular.  Så kontakter en af vores samarbejdspartnere dig på mail eller telefon. "
                            }
           <br />
                            {showText && (
                              <>
                                {language === "en"
                                  ? " You can also stop by Travbyen on 9th of December and register for a home. Read more at "
                                  : "Kom også forbi Travbyen d. 9. december og skriv dig op til en bolig. Læs mere på "
                                }
                                <a
                                  className="h5"
                                  style={{ textDecoration: "none", color: "inherit" }}
                                  href="https://www.travbyen.dk/"
                                  target="_blank"
                                >
                                  www.travbyen.dk
                                </a>
                              </>
                            )}
                          </span>
                        </div>
                      </Box>
          {/* <Box sx={{ fontWeight: 700, lineHeight: 1.4, mb: 3, mt: 4 }}>
            {
              buttonsLabel?.filter(
                (btn) => btn?.UILabelProperty === "SidefodformularOverskrift"
              )[0]?.Label
            }
            <br />
            <br />
            <span
              style={{
                fontSize: "0.95em",
                fontWeight: "normal",
              }}
            >
              {
                buttonsLabel?.filter(
                  (btn) =>
                    btn.UILabelProperty === "SidefodformularUnderoverskrift"
                )[0]?.Label
              }
            </span>
          </Box> */}
        </ContactForm>
      </Box>
      <PoweredBy
        padding={isMobile ? "0 0 66px 0" : "16px 0 16px 0"}
        clr="#004337"
      />
    </Drawer>
  );
};

export default ContactDrawer;
